import * as React from 'react';

export default class SvgDeleteImageIcon extends React.Component<{ className?: string }, {}> {
  render() {
    return (
      <svg
        className="deleteIcon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        strokeWidth="2"
        display="block"
        id="CircleXFill"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm3.707 8.707a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293a1 1 0 1 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293z"
        />
      </svg>
    );
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/DeleteImageIcon.tsx